import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from './types/CodeableConcept';
import Quantity from './types/Quantity';

/**
 * One step of a preset Taper item. Step 1 is the item's own order, so it stores no dose,
 * frequency or interval of its own. A preset states no times, days of week, dates or site:
 * those are supplied when it is applied to a patient.
 */
export default class BN_MedicationPresetTaperStep extends BackboneElement {
    static __className = 'BN_MedicationPresetTaperStep';

    __objectStructure = {
        type: String, // scheduled | prn | hold
        dose: Quantity, // steps 2+ only; unit copied from the item's dose
        frequency: Number,
        period: Number,
        periodUnit: String, // d | wk
        durationValue: Number, // absent only on an open-ended final step
        durationUnit: String, // d | wk | mo
        administrationWindow: Number, // minutes; absent = the account's window at apply time
        selfAdministered: Boolean,
        maxPerDay: Number,
        minimumInterval: Quantity, // FHIR Duration; Quantity is structurally identical
        prnIndication: String,
        holdReason: CodeableConcept,
        holdNotes: String,
    };

    constructor(constructJson, className = 'BN_MedicationPresetTaperStep') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
